import { atom, useSetRecoilState } from "recoil";

const DEFAULT_API_CALL_ERROR = { message: "", httpCode: undefined };

const apiCallErrorAtom = atom({
  key: "apiCallError",
  default: DEFAULT_API_CALL_ERROR,
});

const useResetApiCallErrorAtom = () => {
  const setResetApiCallErrorAtom = useSetRecoilState(apiCallErrorAtom);
  return () => {
    setResetApiCallErrorAtom(DEFAULT_API_CALL_ERROR);
  };
}

export { apiCallErrorAtom, useResetApiCallErrorAtom };
